export default __webpack_public_path__ + "static/media/Montserrat-SemiBold.d27053e9.otf";